import { SET_COLOR_SCHEMA } from "../ActionTypes"

export const setColorSchema = data => dispatch => {
  dispatch({
    type: SET_COLOR_SCHEMA,
    payload: data,
  })
}
